import {
  BaseFlowBlockSchema,
  FlowBlockReturnTypeSchema,
  FlowBlockType,
  FlowProducedType,
} from 'flow-schema';
import { z } from 'zod';

import { RunMode } from '../base/baseSchema.js';

export const AuthorizationSubmissionBlockConfigSchema = z.object({
  mockScenarioId: z.string().optional(),
  patientLastName: z.string().optional(),
  runMode: z.enum(RunMode).default(RunMode.Live),
});
export type AuthorizationSubmissionBlockConfig = z.infer<
  typeof AuthorizationSubmissionBlockConfigSchema
>;

export const AuthorizationSubmissionBlockSchema = BaseFlowBlockSchema.extend({
  type: z.literal(FlowBlockType.AuthorizationSubmission),
  config: AuthorizationSubmissionBlockConfigSchema,
  returnType: FlowBlockReturnTypeSchema(FlowProducedType.PatientOrder),
});
export type AuthorizationSubmissionBlock = z.infer<typeof AuthorizationSubmissionBlockSchema>;
